/**
 * Upload limits shared across web + mobile.
 */
export const UPLOAD_LIMITS = {
    /** Maximum size per file (MB) */
    MAX_FILE_SIZE_MB: 20,
    /** Maximum number of files allowed */
    MAX_FILES: 10,
};
